export { sendSurveyData } from "./client";
